import { cn } from "@/shared/lib/cn";
import { type ChangeEvent } from "react";

type Props = {
  min: number; max: number; step?: number; value: number;
  onChange: (n: number) => void;
  className?: string; fmt?: (n: number) => string;
};

export function Slider({ min, max, step = 1, value, onChange, className, fmt }: Props) {
  const pct = ((value - min) / (max - min)) * 100;
  return (
    <div className={cn("flex items-center gap-4", className)}>
      <input
        type="range"
        min={min} max={max} step={step} value={value}
        onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(Number(e.target.value))}
        className="flex-1 appearance-none h-1.5 rounded-pill bg-ink-12 [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:w-5 [&::-webkit-slider-thumb]:h-5 [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-lime [&::-webkit-slider-thumb]:border-2 [&::-webkit-slider-thumb]:border-ink [&::-webkit-slider-thumb]:cursor-pointer [&::-moz-range-thumb]:w-5 [&::-moz-range-thumb]:h-5 [&::-moz-range-thumb]:rounded-full [&::-moz-range-thumb]:bg-lime [&::-moz-range-thumb]:border-2 [&::-moz-range-thumb]:border-ink"
        style={{ background: `linear-gradient(to right, var(--wb-lime) 0%, var(--wb-lime) ${pct}%, var(--wb-ink-12) ${pct}%, var(--wb-ink-12) 100%)` }}
      />
      {fmt && (
        <span className="font-mono text-[14px] tabular-nums min-w-[80px] text-right">{fmt(value)}</span>
      )}
    </div>
  );
}
